var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApartment = function SvgApartment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 67,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#apartment_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.166,
    height: 6.166,
    x: 52.25,
    y: 28.811,
    rx: 0.771
  })), /*#__PURE__*/React.createElement("rect", {
    width: 6.166,
    height: 6.166,
    x: 52.25,
    y: 28.811,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#apartment_svg__b)",
    rx: 0.771
  }), /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.166,
    height: 6.166,
    x: 61.113,
    y: 28.811,
    rx: 0.771
  })), /*#__PURE__*/React.createElement("rect", {
    width: 6.166,
    height: 6.166,
    x: 61.113,
    y: 28.811,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#apartment_svg__c)",
    rx: 0.771
  }), /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.166,
    height: 6.166,
    x: 52.25,
    y: 38.059,
    rx: 0.771
  })), /*#__PURE__*/React.createElement("rect", {
    width: 6.166,
    height: 6.166,
    x: 52.25,
    y: 38.059,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#apartment_svg__d)",
    rx: 0.771
  }), /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.166,
    height: 6.166,
    x: 61.113,
    y: 38.059,
    rx: 0.771
  })), /*#__PURE__*/React.createElement("rect", {
    width: 6.166,
    height: 6.166,
    x: 61.113,
    y: 38.059,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#apartment_svg__e)",
    rx: 0.771
  }), /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.166,
    height: 6.166,
    x: 52.25,
    y: 47.307,
    rx: 0.771
  })), /*#__PURE__*/React.createElement("rect", {
    width: 6.166,
    height: 6.166,
    x: 52.25,
    y: 47.307,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#apartment_svg__f)",
    rx: 0.771
  }), /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.166,
    height: 6.166,
    x: 61.113,
    y: 47.307,
    rx: 0.771
  })), /*#__PURE__*/React.createElement("rect", {
    width: 6.166,
    height: 6.166,
    x: 61.113,
    y: 47.307,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#apartment_svg__g)",
    rx: 0.771
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M43.389 8.387V68.5m50.865-29.287v29.286M52.635 15.322V68.5m29.287-26.975V68.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M100.034 42.296v26.203H1V8h42.388l9.248 6.936v7.707h21.965l7.322 6.166v13.487-3.468h12.33z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.707,
    height: 7.707,
    x: 7.166,
    y: 14.938,
    rx: 0.771
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.707,
    height: 7.707,
    x: 7.166,
    y: 14.938,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#apartment_svg__h)",
    rx: 0.771
  }), /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.707,
    height: 7.707,
    x: 17.956,
    y: 14.938,
    rx: 0.771
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.707,
    height: 7.707,
    x: 17.956,
    y: 14.938,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#apartment_svg__i)",
    rx: 0.771
  }), /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.707,
    height: 7.707,
    x: 28.745,
    y: 14.938,
    rx: 0.771
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.707,
    height: 7.707,
    x: 28.745,
    y: 14.938,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#apartment_svg__j)",
    rx: 0.771
  }), /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.707,
    height: 7.707,
    x: 7.166,
    y: 26.496,
    rx: 0.771
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.707,
    height: 7.707,
    x: 7.166,
    y: 26.496,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#apartment_svg__k)",
    rx: 0.771
  }), /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.707,
    height: 7.707,
    x: 17.956,
    y: 26.496,
    rx: 0.771
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.707,
    height: 7.707,
    x: 17.956,
    y: 26.496,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#apartment_svg__l)",
    rx: 0.771
  }), /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.707,
    height: 7.707,
    x: 28.745,
    y: 26.496,
    rx: 0.771
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.707,
    height: 7.707,
    x: 28.745,
    y: 26.496,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#apartment_svg__m)",
    rx: 0.771
  }), /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.707,
    height: 7.707,
    x: 7.166,
    y: 38.059,
    rx: 0.771
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.707,
    height: 7.707,
    x: 7.166,
    y: 38.059,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#apartment_svg__n)",
    rx: 0.771
  }), /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.707,
    height: 7.707,
    x: 17.956,
    y: 38.059,
    rx: 0.771
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.707,
    height: 7.707,
    x: 17.956,
    y: 38.059,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#apartment_svg__o)",
    rx: 0.771
  }), /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.707,
    height: 7.707,
    x: 28.745,
    y: 38.059,
    rx: 0.771
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.707,
    height: 7.707,
    x: 28.745,
    y: 38.059,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#apartment_svg__p)",
    rx: 0.771
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.5,
    d: "M74.602 22.645V68.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "apartment_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h101v67H0z"
  })))));
};
export default SvgApartment;